import { CustomAlert } from 'components/AlertsCollection';
import useAlertControl from 'hooks/Meteorology/Agro/WaterBalanceSequential/Maps/useAlertControl';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export default function Alert({ alert }: {
  alert: CustomAlert | undefined;
}) {
  const map = useMap();
  const alertControl = useAlertControl(alert);

  useEffect(() => {
    if (!map || !alertControl) return () => {};

    map.addControl(alertControl);

    return () => {
      map.removeControl(alertControl);
    };
  }, [map, alertControl]);

  return null;
}
